import { FromSchema } from '@40seas/entities/common';
import {
    ScheduledTransactionPeriod,
    ScheduledTransactionSettingsMode,
    ScheduledTransactionSettingsZodObject,
} from './scheduled-transaction-settings.entity';
import { Currency } from '@40seas/models';

export const CreateScheduledTransactionSettingsDtoSchema = ScheduledTransactionSettingsZodObject.refine(
    (data) => {
        if ((data.period === ScheduledTransactionPeriod.monthly || data.period === ScheduledTransactionPeriod.weekly) && !data.value) {
            return false;
        }
        return true;
    },
    {
        message: 'Invalid sync period',
        path: ['period'],
    },
)
    .refine(
        (data) => {
            if (
                !data.value &&
                data.period !== ScheduledTransactionPeriod.daily &&
                data.mode === ScheduledTransactionSettingsMode.Scheduled
            ) {
                return false;
            }

            const value = data?.value ?? NaN;

            if (data.period === ScheduledTransactionPeriod.weekly && (value < 1 || value > 7)) {
                return false;
            }

            if (data.period === ScheduledTransactionPeriod.monthly && (value < 1 || (value > 27 && value !== 31))) {
                return false;
            }

            return true;
        },
        {
            message: 'Invalid sync period value selected',
            path: ['value'],
        },
    )
    .refine(
        (data) => {
            if (!data.account && data.mode === ScheduledTransactionSettingsMode.Automatic) {
                return false;
            }

            return true;
        },
        {
            message: 'You must select an account for automatic transactions',
            path: ['value'],
        },
    );

export class CreateScheduledTransactionSettingsDto extends FromSchema(CreateScheduledTransactionSettingsDtoSchema) {
    period?: ScheduledTransactionPeriod;
    mode: ScheduledTransactionSettingsMode;
    value?: number;
    account?: string;
    currency: Currency;
}
